export const getAllDepartmentDesignationMapping = (api, tokenType) => {
  return api.get("/departmentBasedDesignation", { tokenType });
};

export const getAllDesignations = (api, tokenType) => {
  return api.get("/designation", { tokenType });
};

export const getAllDepartments = (api, tokenType) => {
  return api.get("/trfdepartment", { tokenType });
};
